import { useEffect, useState } from 'react';
import { GridToolbarContainer } from '@mui/x-data-grid-premium';
import { Box, IconButton, Paper } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

import { dataGridPremiumColumns } from '../../../utils/helper';
import { DataGridIdentifiers, AddButtonUi, DatagridPremiumUi } from '../../Interface';
import ProductionReceiptDialog from './ProductionReceiptDialog';
import { InvManagementMethod } from '../../../config/itemGroup';
import ItemBatchLabelDialog from '../../Item/ItemBatchLabelDialog';

const EditToolbar = (props) => {
  const { disabled, setDialogOpen } = props;

  const handleClick = async () => {
    setDialogOpen(true);
  };

  return (
    <GridToolbarContainer>
      <AddButtonUi disabled={disabled} onClick={handleClick} />
    </GridToolbarContainer>
  );
};

const ProductionReceipt = (props) => {
  const { selectedValues, disabled } = props;
  const [reports, setReports] = useState([]);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [labelDialogState, setLabelDialogState] = useState({ open: false, row: null });

  const columns = dataGridPremiumColumns([
    {
      field: 'docNumber',
      headerName: 'Biz. szám',
      type: 'string',
      valueGetter: (_data, row) => row.doc.docNum,
    },
    {
      field: 'itemCode',
      headerName: 'Cikkszám',
      type: 'string',
    },
    {
      field: 'itemName',
      headerName: 'Cikknév',
      type: 'string',
    },
    {
      field: 'batchSn',
      headerName: 'Sarzs',
      type: 'string',
    },
    {
      field: 'qty',
      headerName: 'Mennyiség',
      type: 'string',
      filterable: false,
      renderCell: (data) => {
        let quantity = data.row.qty;

        if (data.row.item.invManagementMethod === InvManagementMethod.BATCH) quantity = data.row.batchQty;
        return quantity;
      },
    },
    {
      field: 'quantityUnitCode',
      headerName: 'Me.',
      type: 'string',
      filterable: false,
      sortable: false,
    },
    {
      field: 'actions',
      headerName: '',
      type: 'string',
      filterable: false,
      sortable: false,
      width: 60,
      renderCell: (data) => {
        const isBatch = data.row.item?.invManagementMethod === InvManagementMethod.BATCH;
        if (!isBatch) return null;
        return (
          <IconButton size="small" onClick={() => setLabelDialogState({ open: true, row: data.row })}>
            <PrintIcon fontSize="small" />
          </IconButton>
        );
      },
    },
  ]);

  useEffect(() => {
    setReports(selectedValues?.receipts ?? []);
  }, [selectedValues]);

  return (
    <>
      <Box sx={{ overflowX: 'auto' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Paper elevation={2} sx={{ overflow: 'hidden', boxShadow: 3, borderRadius: 2, width: '100%' }}>
            <DatagridPremiumUi
              datagridIdentifier={DataGridIdentifiers.ProductionReceipt}
              height={480}
              columns={columns}
              rows={reports}
              slots={{
                toolbar: EditToolbar,
              }}
              slotProps={{
                toolbar: {
                  disabled,
                  setDialogOpen,
                },
              }}
              headerFilters={false}
              getRowHeight={() => 'auto'}
              getRowId={(row) => `${row.docId}_${row.lineNum}`}
            />
          </Paper>
        </Box>
      </Box>
      <ProductionReceiptDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSave={(data) => {
          setReports((prev) => [...prev, data]);
          setDialogOpen(false);
        }}
        {...props}
      />
      <ItemBatchLabelDialog
        open={labelDialogState.open}
        onClose={() => setLabelDialogState({ open: false, row: null })}
        initialBatch={labelDialogState.row?.batchSn ?? ''}
        readonlyBatch
        selectedValuesState={{
          selectedValues: {
            itemCode: labelDialogState.row?.itemCode ?? '',
            itemName: labelDialogState.row?.itemName ?? '',
            quantityUnit: labelDialogState.row?.item?.quantityUnit ?? null,
            barCode: labelDialogState.row?.item?.barCode ?? '',
          },
          setSelectedValues: () => {},
        }}
      />
    </>
  );
};

export default ProductionReceipt;
